"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ResentButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const otpService_js_namespaceObject = require("../../utils/otpService.js");
var otpService_js_default = /*#__PURE__*/ __webpack_require__.n(otpService_js_namespaceObject);
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const StyledLink = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Link).withConfig({
    displayName: "ResentButton__StyledLink"
})([
    "text-decoration:underline;",
    ""
], ({ disabled })=>disabled && `
  text-decoration: none;
  `);
const ResendButton = ({ validOtpCode })=>{
    const errorMessage = "I\u2019m\xa0having\xa0some trouble\xa0accessing your trip information. ";
    const { setOtpRequestErrorMsg, otpResent, setOtpResent, setVerificationApiFunction, resendInProgress, setResendInProgress, otpFormData, otpDeliveryType } = (0, OtpContext_js_namespaceObject.useOtpContext)();
    const [totalResendCount, setTotalResendCount] = (0, external_react_namespaceObject.useState)(1);
    const otpServiceInstance = (0, external_react_namespaceObject.useMemo)(()=>otpService_js_default()({
            deliveryType: otpDeliveryType
        }), [
        otpService_js_default()
    ]);
    const { phoneNumber, email, countryCode } = otpFormData || {};
    const [disableResendButton, setDisableResendButton] = (0, external_react_namespaceObject.useState)(true);
    const { submitChatMessagesPayload, requestFrom } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { cguid, resolvedClientIP } = submitChatMessagesPayload || {};
    const disableResendButtonFn = ()=>{
        setTimeout(()=>{
            setDisableResendButton(false);
        }, 120000);
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        disableResendButtonFn();
    }, []);
    async function resendSmsCode(e) {
        setTotalResendCount(totalResendCount + 1);
        setResendInProgress(true);
        setOtpRequestErrorMsg('');
        try {
            const otpChallenge = await otpServiceInstance.createChallenge({
                phoneNumber,
                email,
                countryCode,
                scope: 'trips',
                requestHeaders: {
                    'x-pcln-client-ip': resolvedClientIP,
                    cguid
                },
                requestFrom
            });
            if (otpChallenge) {
                setVerificationApiFunction(()=>otpServiceInstance.verify);
                setOtpResent(true);
            } else setOtpRequestErrorMsg(errorMessage);
        } catch (e) {
            setOtpRequestErrorMsg(errorMessage);
        } finally{
            setDisableResendButton(true);
            setResendInProgress(false);
            if (totalResendCount <= 4) disableResendButtonFn();
        }
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: resendInProgress ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Spinner, {}) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
            children: !validOtpCode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                        mt: 2,
                        fontSize: 0,
                        children: [
                            "Didn't get the message?",
                            ' ',
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledLink, {
                                disabled: disableResendButton,
                                onClick: resendSmsCode,
                                children: "Resend"
                            })
                        ]
                    }),
                    otpResent ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        fontWeight: 'bold',
                        children: "Message re-sent."
                    }) : null
                ]
            })
        })
    });
};
const ResentButton = ResendButton;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
